/*eslint-disable*/
import React from "react";

// reactstrap components
import { Col, Card, CardBody, Row, Button } from "reactstrap";
import Status from "./Status";
import axios from "axios";
import { Services } from "../../Services";
import Map from "../Sumary/mapShipment";
// import Map from '../../../Components/Maps/map';
import CardResumen from "./Detail";
import TablesData from "./TablesData";
import { Link } from "react-router-dom";
import Loader from "./../../../../Global/Loader/index";

class Sumary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      dataShipmet: [],
      dataShipmetMapDetail: [],
      key: 1,
      loaderMap: false,
      tables: [
        {
          columns: [
            { label: "Port / Airport", key: "RoutingId" },
            { label: "Carrier", key: "Carrier" },
            { label: "Vessel", key: "Vessel" },
            { label: "Voyage / Flight No", key: "Voyage_FlightNo" },
            // { label: 'Origin', key: 'POL' },
            { label: "ETA", key: "EstimatedTimeArrival" },
            { label: "ETD", key: "EstimatedTimeDeparture" },
            // { label: 'estimated arrival date', key: 'EstimatedTimeArrival' },
          ],
          data: [
            {
              TrasnportMode: "FCL",
              LegType: "Leg Type",
              Voyage: "123456789",
              Voyage: "1",
              Origin: "italy",
              Destination: "Mexico",
            },
          ],
          title: "Routing",
          key: "DataRoutes",
        },
        {
          columns: [
            {
              label: "Container Number",
              key: "ContainerId",
              custom: (value) => (
                <Link to={"/Container-Detail/" + value.ContainerId}>
                  {value.NoContainer}
                </Link>
              ),
            },
            {
              label: "Status",
              key: "Estatus",
              custom: (value) =>
                value.Estatus ? (
                  <span className="badge-inter">
                    {value.Estatus}
                  </span>
                ) : false,
            },
            { label: "Container Type", key: "ContainerType" },
            { label: "Total Piece", key: "Pieces" },
            { label: "Total Weight", key: "Weight" },
            { label: "Volume", key: "Volume" },
            { label: "Temperature", key: "Temperature" },

            // { label: 'ConsigneeName', key: 'ConsigneeName' },
          ],
          data: [
            {
              Containers: "2000",
              Status: "Booked",
              ContainerType: "4RH",
              Seal: "Seal",
              TotalPieces: "1000",
              TotalWeigth: "2500 kg",
              Temperature: "12 °C",
            },
          ],
          title: "Containers",
          key: "DataContainers",
        },
      ],
      tables2: [
        {
          columns: [
            { label: "RoutingId", key: "RoutingId" },
            { label: "Vessel", key: "Vessel" },
            { label: "Voyage", key: "Voyage_FlightNo" },
            // { label: 'Origin', key: 'POL' },
            { label: "Destination", key: "POD" },
            // { label: 'estimated arrival date', key: 'EstimatedTimeArrival' },
          ],
          data: [
            {
              TrasnportMode: "FCL",
              LegType: "Leg Type",
              Voyage: "123456789",
              Voyage: "1",
              Origin: "italy",
              Destination: "Mexico",
            },
          ],
          title: "Routing",
          key: "DataRoutes",
        },
        {
          columns: [
            { label: "Weight", key: "Weight" },
            { label: "Volumen", key: "Volume" },
            { label: "Pieces", key: "Pieces" },
            { label: "Temperature", key: "Temperature" },
          ],
          data: [
            {
              Containers: "2000",
              Status: "Booked",
              ContainerType: "4RH",
              Seal: "Seal",
              TotalPieces: "1000",
              TotalWeigth: "2500 kg",
              Temperature: "12 °C",
            },
          ],
          title: "Packages",
          key: "DataContainers",
        },
      ],
      TerrestreTable: [
        {
          columns: [
            { label: "RoutingId", key: "RoutingId" },
            { label: "Vessel", key: "Vessel" },
            { label: "Voyage", key: "Voyage_FlightNo" },
            // { label: 'Origin', key: 'POL' },
            { label: "Destination", key: "POD" },
            // { label: 'estimated arrival date', key: 'EstimatedTimeArrival' },
          ],
          data: [
            {
              TrasnportMode: "gfgf",
              LegType: "fgfgf",
              Voyage: "123456789",
              Voyage: "1",
              Origin: "italy",
              Destination: "Mexico",
            },
          ],
          title: "Routing",
          key: "DataRoutes",
        },
        {
          columns: [
            { label: "Container Type", key: "ContainerType" },
            { label: "Total Pieces", key: "Pieces" },
            { label: "Total Weight", key: "Weight" },
            { label: "Volumen", key: "Volume" },
            { label: "Temperature", key: "Temperature" },
          ],
          data: [
            {
              Containers: "2000",
              Status: "Booked",
              ContainerType: "4RH",
              Seal: "Seal",
              TotalPieces: "1000",
              TotalWeigth: "2500 kg",
              Temperature: "12 °C",
            },
          ],
          title: "Full Truck Load",
          key: "DataContainers",
        },
      ],
      markers: [],
      Resumen: [],
    };
  }

  componentDidMount = () => {
    this.getShipmentsForId();
  };

  getShipmentsForId = () => {
    axios
      .get(
        `${Services.Get_ShipmentId.path}shipments/dataShipments/${this.state.id}`
      )
      .then((response) => {
        let isContenedor = false;
        let isTerrestre = false;
        let historico = response.data.data.historico
        if (response.data.data.DataShipment[0].TransportMode === "FCL") {
          isContenedor = true;
        }
        else if (response.data.data.DataShipment[0].TransportMode === "InLand") {
          isTerrestre = true;
        }
        response.data.data.DataShipment[0].historico = historico
        let newTabla = (isContenedor
          ? this.state.tables
          : isTerrestre
            ? this.state.TerrestreTable
            : this.state.tables2
        ).map((f) => {
          f.data =
            response.data.data[f.key] && response.data.data[f.key].length > 0
              ? response.data.data[f.key]
              : [{}];
          return f;
        });
        this.setState(
          {
            dataShipmet: response.data.data.DataShipment[0],
            dataShipmetMapDetail: response.data.data.DataShipment,
            tables: newTabla,
            loaderMap: true,
            key: Math.random(),
          },
          () => {
            this.getDataMap();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getDataMap = () => {
    let { dataShipmetMapDetail } = this.state;

    let markers = [];
    let polylineData = [];

    dataShipmetMapDetail.map((e, index) => {
      if (
        e.OriginLatitud &&
        e.OriginLongitude &&
        e.destinationLatitud &&
        e.destinationLongitude
      ) {
        if (e.OriginLatitud && e.OriginLongitude) {
          let obj = {
            // anchor: 30,
            // key: `${index}From`,
            title: "Origin",
            name: e.ShipmentId,
            data: e,
            position: {
              lat: e.OriginLatitud,
              lng: e.OriginLongitude,
            },
            icon: {
              url:
                e.ModoTransporte === "AEREA"
                  ? "https://fsposeidon.blob.core.windows.net/files/airplane (1).png"
                  : e.ModoTransporte === "MARITIMA"
                    ? "https://fsposeidon.blob.core.windows.net/files/cruise-poseidon.png"
                    : "https://fsposeidon.blob.core.windows.net/magicvisionpic/truck.png",
            },
          };

          let position = {
            lat: Number(e.OriginLatitud),
            lng: Number(e.OriginLongitude),
          };
          polylineData.push(position);
          markers.push(obj);
        }
        if (e.destinationLatitud && e.destinationLongitude) {
          let obj = {
            key: `${index}To`,
            title: "destination",
            name: e.ShipmentId,
            data: e,
            position: {
              lat: e.destinationLatitud,
              lng: e.destinationLongitude,
            },
            icon: {
              url:
                e.ModoTransporte === "AEREA"
                  ? "https://fsposeidon.blob.core.windows.net/files/airplane (1).png"
                  : e.ModoTransporte === "MARITIMA"
                    ? "https://fsposeidon.blob.core.windows.net/files/cruise-poseidon.png"
                    : "https://fsposeidon.blob.core.windows.net/magicvisionpic/truck.png",
            },
          };
          let position = {
            lat: Number(e.destinationLatitud),
            lng: Number(e.destinationLongitude),
          };
          polylineData.push(position);
          markers.push(obj);
        }
      }
      return e;
    });
    this.setState({
      markers: markers,
      polyline: polylineData,
    });
  };

  render() {
    let { markers, dataShipmet, polyline, loaderMap } = this.state;
    return (
      <>
        <Loader hidden={loaderMap}></Loader>
        <div className="content">
          <Col xs={12} md={12} style={{ padding: "0px 0px 0px 0px" }}>
            <Status
              data={dataShipmet}
              steps={this.props.steps}
              key={this.state.key}
            />
          </Col>
          <Col xs={12} md={12} style={{ padding: "0px 0px 0px 0px" }}>
            <Card className="myCard">
              <CardBody>
                <Map marker={markers} polyline={polyline} />
              </CardBody>
            </Card>
          </Col>
          <div className="col-12">
            <Row>
              <Col
                md={4}
                lg={4}
                sm={12}
                style={{ padding: "0px 15px 15px 0px" }}
              >
                <CardResumen data={dataShipmet} key={this.state.key}>
                  {" "}
                </CardResumen>
              </Col>
              <Col
                md={8}
                lg={8}
                sm={12}
                style={{ padding: "0px 0px 15px 15px" }}
              >
                {this.state.tables.map((e, index) => {
                  return (
                    <TablesData
                      columns={e.columns}
                      data={e.data}
                      key={index}
                      itemsByPage={10}
                      title={e.title}
                      options={{
                        pagination: false,
                        search: false,
                        downloads: {
                          xlsx: false,
                          pdf: false,
                        },
                      }}
                    />
                  );
                })}
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}

export default Sumary;
